import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=c5b4fb3c&scoped=true"
import script from "./robot.vue?vue&type=script&lang=js"
export * from "./robot.vue?vue&type=script&lang=js"
import style0 from "./robot.vue?vue&type=style&index=0&id=c5b4fb3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b4fb3c",
  null
  
)

export default component.exports